import React, { ReactElement } from "react";
import OrderVatTaxReport from "../../components/Finance/OrderVatTaxReport";
import Layout from "../../components/layout";

const OrderVatTaxPage = (): ReactElement => {
  return (
    <Layout>
      <OrderVatTaxReport />
    </Layout>
  );
};

export default OrderVatTaxPage;
